import { render, staticRenderFns } from "./Celebrations.vue?vue&type=template&id=75f4ddba"
import script from "./Celebrations.vue?vue&type=script&lang=js"
export * from "./Celebrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports